import dayjs from "dayjs";
import { OutsourceOrder } from "../../../data/entities";
import { normalizeOutsourceMaterials } from "../utils";
import {
    convertNumberToVietnameseMoneyText,
    formatNumberToCustomStyle,
    formatNumberToCustomStyleWithoutDecimal,
} from "../../../utils/format";

const formatDate = (value: any) => value && dayjs(value).isValid() ? dayjs(value).format("DD/MM/YYYY") : "";

// Use the saved order's agreed quantities and prices, never today's catalog price.
export const buildOutsourceOrderDocument = (order: OutsourceOrder) => {
    const materials = normalizeOutsourceMaterials(order.materials || []);
    const providerRelation: any = materials.flatMap(item => item.outsource_providers || [])
        .find((item: any) => String(item.provider?.id) === String(order.provider_id));
    const provider = providerRelation?.provider;
    const total = materials.reduce((sum, item) => sum + Number(item.selectedQuantity) * Number(item.provider_price || 0), 0);
    return {
        provider_name: order.provider_name || "",
        address: provider?.address || "",
        tax_ID: provider?.tax_id || "",
        phone_number: provider?.phone || "",
        email: provider?.email || "",
        order_name: order.name || order.id,
        order_note: order.note || "",
        order_date: formatDate(order.created_at),
        delivery_date: formatDate(order.due_date),
        materials: materials.map((item, index) => ({
            index: index + 1,
            material_name: item.name || "",
            material_code: item.material_code || "",
            measurement_unit: item.measurement_unit || "",
            quantity: formatNumberToCustomStyle(Number(item.selectedQuantity)),
            price: formatNumberToCustomStyle(Number(item.provider_price || 0)),
            material_total_price: formatNumberToCustomStyleWithoutDecimal(Number(item.selectedQuantity) * Number(item.provider_price || 0)),
        })),
        order_total_price: formatNumberToCustomStyleWithoutDecimal(total),
        total_value_in_text: convertNumberToVietnameseMoneyText(total),
    };
};
